import { createArrivalId } from '@/businessRepository/idUtils';
import { IArrival } from '../entities/arrival';

/**
 * 入荷のファクトリークラス
 */
export class ArrivalFactory {
  /**
   * IArrivalを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IArrival>): IArrival => {
    const arrival: Required<IArrival> = {
      arrivalId: initialData.arrivalId ?? '',
      amount: initialData.amount ?? 0,
      leadTime: initialData.leadTime ?? 0,
      fixOrderDate: initialData.fixOrderDate,
      crossDate: initialData.crossDate,
      year: initialData.year ?? 1,
      month: initialData.month ?? 1,
      day: initialData.day ?? 1,
      status: initialData.status,
      isFixOrdered: initialData.isFixOrdered,
      memoText: initialData.memoText,
      number: initialData.number,
      updateAt: initialData.updateAt,
      partialDeliveries: initialData.partialDeliveries ?? [], // 分納の情報
    };
    return arrival;
  };
}
